export default "__VITE_ASSET__DhWGzxQk__"